import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ChromeReaderMode from "@material-ui/icons/ChromeReaderMode";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import PeopleIcon from "@material-ui/icons/People";
import BarChartIcon from "@material-ui/icons/BarChart";
import LayersIcon from "@material-ui/icons/Layers";
import AssignmentIcon from "@material-ui/icons/Assignment";
import HomeIcon from "@material-ui/icons/Home";
import TheatersIcon from "@material-ui/icons/Theaters";
import ClockIcon from "@material-ui/icons/AccessTime";
import ConfirmationNumberIcon from "@material-ui/icons/ConfirmationNumber";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";
import { Link } from "react-router-dom";

class MainListItems extends React.Component {
    render() {
        return (
            <React.Fragment>
                <ListItem component={Link} to="/" button disabled={false}>
                    <ListItemIcon>
                        <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary="Home" />
                </ListItem>
                <ListItem component={Link} to="/houses" button disabled={false}>
                    <ListItemIcon>
                        <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Houses" />
                </ListItem>
                <ListItem component={Link} to="/chains" button disabled={false}>
                    <ListItemIcon>
                        <PeopleIcon />
                    </ListItemIcon>
                    <ListItemText primary="Chains" />
                </ListItem>
                <ListItem component={Link} to="/vendors" button disabled={false}>
                    <ListItemIcon>
                        <ShoppingCartIcon />
                    </ListItemIcon>
                    <ListItemText primary="Vendors" />
                </ListItem>
                <ListItem component={Link} to="/movies" button disabled={false}>
                    <ListItemIcon>
                        <TheatersIcon />
                    </ListItemIcon>
                    <ListItemText primary="MovieGuide" />
                </ListItem>
                <ListItem component={Link} to="/schedule" button disabled={false}>
                    <ListItemIcon>
                        <ClockIcon />
                    </ListItemIcon>
                    <ListItemText primary="Showtimes" />
                </ListItem>
                <ListItem component={Link} to="/automaters" button disabled={false}>
                    <ListItemIcon>
                        <BarChartIcon />
                    </ListItemIcon>
                    <ListItemText primary="Automaters" />
                </ListItem>
                <ListItem component={Link} to="/perfs" button disabled={false}>
                    <ListItemIcon>
                        <ConfirmationNumberIcon />
                    </ListItemIcon>
                    <ListItemText primary="Perfs" />
                </ListItem>
                <ListItem component={Link} to="/tiktok" button>
                    <ListItemIcon>
                        <LayersIcon />
                    </ListItemIcon>
                    <ListItemText primary="TikTok/PGLoad" />
                </ListItem>
                <ListItem component={Link} to="/api/users" button>
                    <ListItemIcon>
                        <LayersIcon />
                    </ListItemIcon>
                    <ListItemText primary="API User Management" />
                </ListItem>
            </React.Fragment>
        );
    }
}

class ReportListItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    handleCollapseClick = () => {
        this.setState((state) => ({ open: !state.open }));
    };
    render() {
        return (
            <List>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingLeft: 16,
                        paddingRight: 16,
                        height: 48,
                    }}
                    onClick={this.handleCollapseClick}
                >
                    <span style={{ flexGrow: 1 }}>Reports</span>
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                </div>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <ListItem component={Link} to="/opening" button>
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Opening Info" />
                    </ListItem>
                    <ListItem component={Link} to="/bookinglinks" button>
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Booking Links" />
                    </ListItem>
                    <ListItem component={Link} to="/schedulestatus" button>
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Schedule Status" />
                    </ListItem>
                    <ListItem component={Link} to="/reports" button>
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Showtime Report" />
                    </ListItem>
                </Collapse>
            </List>
        );
    }
}

class MovieGuideReportsListItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    handleCollapseClick = () => {
        this.setState((state) => ({ open: !state.open }));
    };

    render() {
        return (
            <List>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingLeft: 16,
                        paddingRight: 16,
                        height: 48,
                    }}
                    onClick={this.handleCollapseClick}
                >
                    <span style={{ flexGrow: 1 }}>MovieGuide Reports</span>
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                </div>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <ListItem component={Link} to="/remaps" button>
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Remaps" />
                    </ListItem>
                    <ListItem component={Link} to="/movie-dupes" button>
                        <ListItemIcon>
                            <AssignmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Movie Dupes" />
                    </ListItem>
                </Collapse>
            </List>
        );
    }
}

class ImportToolsListItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    handleCollapseClick = () => {
        this.setState((state) => ({ open: !state.open }));
    };

    render() {
        return (
            <List>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        paddingLeft: 16,
                        paddingRight: 16,
                        height: 48,
                    }}
                    onClick={this.handleCollapseClick}
                >
                    <span style={{ flexGrow: 1 }}>Import Tools</span>
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                </div>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <ListItem component={Link} to="/imports" button>
                        <ListItemIcon>
                            <LayersIcon />
                        </ListItemIcon>
                        <ListItemText primary="Imports" />
                    </ListItem>
                    <ListItem component={Link} to="/map-codes/list" button>
                        <ListItemIcon>
                            <LayersIcon />
                        </ListItemIcon>
                        <ListItemText primary="Map codes" />
                    </ListItem>
                    <ListItem component={Link} to="/stills" button>
                        <ListItemIcon>
                            <LayersIcon />
                        </ListItemIcon>
                        <ListItemText primary="Stills management" />
                    </ListItem>
                    <ListItem component={Link} to="/generic" button disabled={false}>
                        <ListItemIcon>
                            <ChromeReaderMode />
                        </ListItemIcon>
                        <ListItemText primary="GenericUI" />
                    </ListItem>
                    <ListItem component={Link} to="/fanweb" button>
                        <ListItemIcon>
                            <LayersIcon />
                        </ListItemIcon>
                        <ListItemText primary="Fandango Houses" />
                    </ListItem>
                </Collapse>
            </List>
        );
    }
}

export {
    MainListItems,
    ReportListItems,
    MovieGuideReportsListItems,
    ImportToolsListItems
};